// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1w9Yo","top":"styles_top__3UtQB"};